import anime from 'animejs'
import { getAll } from '@bigyouth/base'

const INITAL_SETTERS = {
  default: () => {},
  fadeImages: (target) => {
    const images = getAll('[anim-picture]', target)
    images.forEach((image) => { image.style.opacity = 0 })
  },
}

const ANIMATIONS = {
  default: () => {},
  fadeImages: (target) => {
    const images = getAll('[anim-picture]', target)

    anime({
      targets: images,
      opacity: 1,
      translateY: ['80px', 0],
      scaleY: [1.05, 1],
      duration: 1000,
      delay: (el, i, l) => i * 250,
      easing: 'easeOutCubic',
    })
  },
}

/**
 * ScrollAnimations manage all the animations launched when a target enter the screenview.
 *
 * js-scroll-animations should should be added on the parent containing all the targets.
 * data-scroll-animation-id="[ID]" should be added on all the targets. [ID] is optional, if none is specified, 'default' animation is launched.
 * data-scroll-animation-threshold can be added to the targets, it add a new threshold for this element instead of the default one DEFAULT_INTERSECTION_THRESHOLD.
 */
export default {
  name: 'scroll-animations',

  ui: {
    'targets[]': '[data-scroll-animation-id]',
  },

  componentDidMount () {
    const observerOptions = {
      root: null,
      rootMargin: '-40% 0px -40% 0px',
      threshold: 0.0,
    }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animationId = entry.target.getAttribute('data-scroll-animation-id') || 'default'
          const animationFunction = ANIMATIONS[animationId] || ANIMATIONS.default

          observer.unobserve(entry.target)
          animationFunction(entry.target)
        }
      })
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions)

    this.ui.targets.forEach((target) => {
      const animationId = target.getAttribute('data-scroll-animation-id') || 'default'
      const initialSetter = INITAL_SETTERS[animationId] || INITAL_SETTERS.default

      initialSetter(target)

      observer.observe(target)
    })
  },
}
